'use strict';

import React from 'react';
import {Link} from 'react-router';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import InvoiceStore from "../../stores/InvoiceStore";
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, TimePicker, DatePicker } from 'material-ui-pickers';
import ViewBills from './ViewBills';


var self;

class Bills extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            profile: {},
            unpaidInvoices: [],
            paidPayments: [],
            paidKeys: [],
            unpaidKeys: [],
            selectedDate: new Date('2014-08-18T21:11:54'),
        };
        this.updateInvoices = this.updateInvoices.bind(this);
        self = this;
    }

    componentWillMount() {
        this.setState({
            profile: InvoiceStore.getProfile(),
            unpaidInvoices: InvoiceStore.getOutStandingPayments(),
            paidPayments: InvoiceStore.getPaidPayments(),
            unpaidKeys: InvoiceStore.getUnpaifKeys(),
            paidKeys: InvoiceStore.getPaidKeys()

        });
        InvoiceStore.on("change", this.updateInvoices);
        Connections.getMyProfile();
    }

    updateInvoices() {
        this.setState({
            profile: InvoiceStore.getProfile(),
            unpaidInvoices: InvoiceStore.getOutStandingPayments(),
            paidPayments: InvoiceStore.getPaidPayments(),
            unpaidKeys: InvoiceStore.getUnpaifKeys(),
            paidKeys: InvoiceStore.getPaidKeys()
        },function () {
            console.log(this.state)
        });
    }
    handleDateChange = date => {
        this.setState({ selectedDate: date });
    };

    render() {
        return (
            <DocumentTitle title="Khula - Billing">
                <div  style={{width:"75%",marginLeft:"12.5%"}}>
                    {/*<MuiPickersUtilsProvider utils={DateFnsUtils}>*/}
                        {/*<Grid container className={{width: '60%'}} justify="space-around">*/}
                            {/*<DatePicker*/}
                                {/*margin="normal"*/}
                                {/*label="Date picker"*/}
                                {/*value={this.state.selectedDate}*/}
                                {/*onChange={this.handleDateChange}*/}
                            {/*/>*/}
                            {/*<TimePicker*/}
                                {/*margin="normal"*/}
                                {/*label="Time picker"*/}
                                {/*value={this.state.selectedDate}*/}
                                {/*onChange={this.handleDateChange}*/}
                            {/*/>*/}
                        {/*</Grid>*/}
                    {/*</MuiPickersUtilsProvider>*/}
                    <div className="uk-grid-small uk-flex-row uk-text-center">

                        <div className="col-sm-6 col-xs-12 col-lg-6 col-md-6  ">
                            <strong>Outstanding Invoices</strong>
                            <div>
                                {this.state.unpaidKeys.map((getKey, i) =>
                                    <ViewBills keySet={getKey} temp={{
                                        "data": self.state.unpaidInvoices[getKey],
                                        "key": getKey,
                                        "profile": self.state.profile,
                                        "paid": false
                                    }}/>
                                )}
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12 col-lg-6 col-md-6  ">
                            <strong>Paid Invoices</strong>
                            <div>
                                {this.state.paidKeys.reverse().map((getKey, i) =>
                                    <ViewBills keySet={getKey} temp={{
                                        "data": self.state.paidPayments[getKey],
                                        "key": getKey,
                                        "profile": self.state.profile,
                                        "paid": true
                                    }}/>
                                )}
                            </div>
                        </div>
                        {/*<th><span className="input-group-btn"><button type="button" className="btn btn-primary" onClick={(e)=>this.handleOpen(this.state.unpaidInvoices)}>Generate combined invoice</button></span> </th>*/}
                        {/*<hr/>*/}

                        {/*<div className="col-sm-2 col-xs-12 col-lg-2 col-md-2 addPadding ">*/}
                            {/*<div className="wrapper uk-card uk-card-hover ">*/}
                                {/*<div className="card radius shadowDepth1">*/}
                                    {/*<div className="uk-grid-small uk-flex-row uk-text-center"*/}
                                    {/*>*/}
                                        {/*<FormControl className={{*/}

                                            {/*minWidth: 120,*/}
                                        {/*}}>*/}
                                            {/*<InputLabel htmlFor="age-simple">All</InputLabel>*/}
                                            {/*<Select*/}
                                                {/*value={this.state.selectedYear}*/}
                                                {/*onChange={(e) => this.processYearDemand(e.target.value)}*/}
                                                {/*inputProps={{*/}
                                                    {/*name: 'year',*/}
                                                    {/*id: 'age-simple',*/}
                                                {/*}}*/}
                                            {/*>*/}
                                                {/*<MenuItem value="">*/}
                                                    {/*<em>None</em>*/}
                                                {/*</MenuItem>*/}
                                                {/*<MenuItem value={2015}>2015 Utilization</MenuItem>*/}
                                                {/*<MenuItem value={2030}>2030 Utilization</MenuItem>*/}
                                                {/*<MenuItem value={2046}>2046 Utilization</MenuItem>*/}
                                            {/*</Select>*/}
                                        {/*</FormControl>*/}
                                        {/*/!*<input type="checkbox" className="btn-toggle-fullwidth"*!/*/}
                                        {/*/!*onChange={() => this.updateSelected("all")}/><b>All</b>*!/*/}

                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                        {/*group.push("Coal System  - ( Ogies - Richards Bay)")*/}
                        {/*group.push("Coal System  - ( Lephalale - Ogies)")*/}
                        {/*group.push("Coal System  - ( Phuzumoya - Richards Bay)")*/}
                        {/*group.push("Coal System  - ( Waterberg)")*/}
                        {/*<div className="col-sm-3 col-xs-12 col-lg-3 col-md-3 addPadding ">*/}
                            {/*<div className="wrapper uk-card uk-card-hover ">*/}
                                {/*<div className="card radius shadowDepth1">*/}
                                    {/*<div className="uk-grid-small uk-flex-row uk-text-center">*/}

                                        {/*<FormControlLabel control={<Checkbox*/}
                                            {/*checked={this.state.coalSelectedOgies}*/}
                                            {/*onChange={this.handleChange('coalSelectedOgies')}*/}
                                            {/*value="coalSelectedOgies"*/}
                                            {/*color="primary"*/}
                                        {/*/>*/}
                                        {/*} label="Coal System  - ( Ogies - Richards Bay)"/>*/}


                                    {/*</div>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </DocumentTitle>
        );
    }

}

export default Bills;



// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/Bills.js